export const TOKEN_KEY = 'eh_token';

export function apiFetch(url, options = {}) {
  const token = sessionStorage.getItem(TOKEN_KEY);
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  return fetch(url, { ...options, headers }).then(res => {
    if (res.status === 401) {
      window.dispatchEvent(new CustomEvent('auth-expired'));
      throw new Error('Session expired');
    }
    return res;
  });
}
